export interface ThemeColor {
    id: string;
    colorClass: string;
}

export const DEFAULT_THEME_COLORS: ThemeColor[] = [
    {id: "GRAY", colorClass: "bg-[#4B5563]"},
    {id: "PRIMARY", colorClass: "bg-[#00575C]"},
    {id: "EMERALD", colorClass: "bg-[#059669]"},
    {id: "LIME", colorClass: "bg-[#65A30D]"},
    {id: "YELLOW", colorClass: "bg-[#CA8A04]"},
    {id: "ORANGE", colorClass: "bg-[#EA580C]"},
    {id: "RED", colorClass: "bg-[#DC2626]"},
    {id: "FUCHSIA", colorClass: "bg-[#C026D3]"},
    {id: "VIOLET", colorClass: "bg-[#9333EA]"},
    {id: "INDIGO", colorClass: "bg-[#4F46E5]"},
    {id: "SKY", colorClass: "bg-[#0284C7]"},
];


